<template>
	<Button @click="onClick" type="default" :size="size" :disabled="disabled">
		<template #icon>
			<IconArrowEndRectangle :size="size" style="margin-right: 4px" />
		</template>
		<slot />
	</Button>
</template>

<script>
import Button from './Button.vue'
import IconArrowEndRectangle from '../icon/IconArrowEndRectangle.vue'
import ButtonMixin from './ButtonMixin.js'
export default {
	mixins: [ButtonMixin],
	components: {
		Button,
		IconArrowEndRectangle
	}
}
</script>
